import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-cancela-agenda-client',
  templateUrl: './cancela-agenda-client.component.html',
  styleUrls: ['./cancela-agenda-client.component.scss']
})
export class CancelaAgendaClientComponent implements OnInit {
  agendaInfo: string;

  constructor(private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    const agendaId = this.activatedRoute.snapshot.params['id'];
    const minhaAgenda = JSON.parse(sessionStorage.getItem('minhaAgenda'));
    const agendamento = minhaAgenda.find(item => item.id === +agendaId);
    const { data, hora, agenda_nome, especialidade_nome } = agendamento;

    const dataSplit = data.slice(0, 10).split('-');
    const dataParsed = `${dataSplit[2]}/${dataSplit[1]}/${dataSplit[0]}`;

    this.agendaInfo = `Agendamento: ${dataParsed} ${hora} Dr. ${agenda_nome}
      Especialidade: ${especialidade_nome}`;
  }
}
